document.addEventListener('DOMContentLoaded', function() {
  

  if (typeof casestudy_category_preference !== 'undefined' && casestudy_category_preference) {
      updateCookieIfValid('casestudy_category_preference', casestudy_category_preference, 7);
  }

  if (typeof post_category_preference !== 'undefined' && post_category_preference) {
      updateCookieIfValid('post_category_preference', post_category_preference, 7);
  }
});
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function updateCookieIfValid(name, value, days) {
  console.log("inside update function");
  if (Array.isArray(value) && value.length > 0 && value.every(Number.isInteger)) {
    console.log("setting cookie");
      setCookie(name, JSON.stringify(value), days);
  }
}